'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["businessUnitId", "hasBusinessUnitsAccess", "isUngatedForCampaignBusinessUnit"];
import { connect } from 'react-redux';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import ContentRoutes from 'ContentUtils/Routes';
import { Button } from 'foundations-components/transitional/components/Button';
import { getLegalConsentSubscriptionsFilter } from 'FormsCommonComponents/utils/BusinessUnitsUtils';
import SubscriptionTypeSelect from 'ui-gdpr-components/components/SubscriptionTypeSelect';
import { getCurrentFormBusinessUnitId } from 'FormsUI/selectors/Editor';
import { getUnavailableEmailSubscriptionsIdsByFormBusinessUnit } from 'FormsUI/selectors/LegalConsentPanel';
import { hasBusinessUnitsAccess as getHasBusinessUnitsAccess } from 'FormsUI/selectors/BusinessUnitsAccess';
import { isUngatedForCampaignBusinessUnit as getIsUngatedForCampaignBusinessUnit } from 'FormsUI/selectors/Gates';
import { jsx as _jsx } from "react/jsx-runtime";
const SUBSCRIPTION_TYPES_URL = ContentRoutes.settings('email', 'types');
const AddSubscriptionFooter = () => /*#__PURE__*/_jsx(Button, {
  external: true,
  use: "link",
  href: SUBSCRIPTION_TYPES_URL,
  "data-selenium": "manage-button",
  marginInlineStart: "200",
  children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "subscriptionTypeSelect.addSubscription"
  })
});
const SubscriptionTypeSelectContainer = props => {
  const {
      businessUnitId,
      hasBusinessUnitsAccess,
      isUngatedForCampaignBusinessUnit
    } = props,
    propsRest = _objectWithoutPropertiesLoose(props, _excluded);
  const customFilter = getLegalConsentSubscriptionsFilter({
    businessUnitId,
    hasBusinessUnitsAccess,
    isUngatedForCampaignBusinessUnit
  });
  return /*#__PURE__*/_jsx(SubscriptionTypeSelect, Object.assign({}, propsRest, {
    customFilter: customFilter,
    customFooter: /*#__PURE__*/_jsx(AddSubscriptionFooter, {})
  }));
};
const mapStateToProps = state => ({
  businessUnitId: getCurrentFormBusinessUnitId(state),
  hasBusinessUnitsAccess: getHasBusinessUnitsAccess(state),
  isUngatedForCampaignBusinessUnit: getIsUngatedForCampaignBusinessUnit(state),
  subscriptionIdsToHide: getUnavailableEmailSubscriptionsIdsByFormBusinessUnit(state)
});
const actionsToBind = {};
export default connect(mapStateToProps, actionsToBind)(SubscriptionTypeSelectContainer);